module.exports = __webpack_public_path__ + "img/resolute.055c8f6d.webp";